import $ from 'jquery';

class Video {
    constructor({ trigger }) {
        const triggers = document.querySelectorAll('.js-play');

        $(triggers).click(function () {
            const $container = $(this).parents('.video');
            $container.find('iframe')[0].src += '&autoplay=1';
            $container.addClass('js-state-video-active');
        })
    }
}

export default Video;



// WEBPACK FOOTER //
// ./components/views/video.js